import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {ImageTypeEnum} from '../../shared/graphql/globalTypes';
import {ToastrService} from 'ngx-toastr';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const SkideoVideoPlayer: any;

interface Content {
  created_at: Date;
  title: string;
  type: number;
  url: string;
}

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  standalone: false,
})
export class LandingComponent implements OnInit {
  ImageTypeEnum = ImageTypeEnum;
  url = '';

  date: Date = new Date();
  content: Content = {
    created_at: new Date(),
    title: '',
    type: 1,
    url: '',
  };
  suffix = '';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    @Inject(LOCALE_ID) public locale: string,
    private router: Router,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    if (this.locale === 'en') {
      this.suffix = 'th';
    }

    this.url = location.origin + this.router.url;

    const hash = this.route.snapshot.params['hash'];
    const type = this.route.snapshot.params['type'];
    const lookupId = this.route.snapshot.params['lookup_id'];

    this.http
      .get(environment.host + 'api/get_content_url', {
        params: {
          content_id: hash,
          lookup_id: lookupId,
          content_type: type.toUpperCase(),
        },
      })
      .subscribe(data => {
        this.content = data as Content;
        setTimeout(() => {
          if (this.content.type !== 3) {
            return;
          }
          const videoEl = document.getElementById('video');
          SkideoVideoPlayer.trackVideo(videoEl, hash, lookupId, environment.host);
        });
      });
  }

  copyUrl(): void {
    this.toastr.success($localize`Copied`);
  }
}
